/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface CreatePlaylistResponse
 */
export interface CreatePlaylistResponse {
  /**
   * The unique identifier for the Playlist.
   * @type number
   * @memberof CreatePlaylistResponse
   */
  playlistKey: number
  /**
   * Display name of the playlist.
   * @type string
   * @memberof CreatePlaylistResponse
   */
  name: string
  /**
   * Defines the category of the playlist.'LearningCenter' or 'BusinessCenter' content.
   * @type string
   * @memberof CreatePlaylistResponse
   */
  playlistType: CreatePlaylistResponsePlaylistTypeEnum
}

/**
 * @export
 * @enum {string}
 */
export enum CreatePlaylistResponsePlaylistTypeEnum {
  LearningCenter = 'LearningCenter',
  BusinessCenter = 'BusinessCenter',
}

export function CreatePlaylistResponseFromJSON(
  json: any
): CreatePlaylistResponse {
  return CreatePlaylistResponseFromJSONTyped(json, false)
}

export function CreatePlaylistResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreatePlaylistResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    playlistKey: json['playlistKey'],
    name: json['name'],
    playlistType: json['playlistType'],
  }
}

export function CreatePlaylistResponseToJSON(
  value?: CreatePlaylistResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    playlistKey: value.playlistKey,
    name: value.name,
    playlistType: value.playlistType,
  }
}
